import { createAsyncThunk } from '@reduxjs/toolkit'
import { ColumnFiltersState } from '@tanstack/react-table'
import { Axios } from 'api/axios'
import axios from 'axios'
// import { LoDashStatic } from 'lodash'
const API_URL = process.env.REACT_APP_BASE_URL
const headers = {
  'Content-Type': 'application/json'
}

export interface UserType {
  id?: number
  usersType: string
  districtCode: string
  districtName: string
  state: string
  status: boolean
  createBy?: string
  updatedBy?: string
  createDate?: string
  updateDate?: string
}
export interface PaginatedResponse<T> {
  count: number
  total_pages: number
  next: string | null
  previous: string | null
  results: T[]
}

export const fetchUsersType = createAsyncThunk(
  'department/fetchUsersType',
  async ({
    page,
    pageSize,
    search,
    sort,
    order,
    filters
  }: {
    page: number
    pageSize: number
    search?: string
    sort?: string
    order?: 'asc' | 'desc' | ''
    filters?: ColumnFiltersState
  }) => {
    try {
      const params: Record<string, any> = {
        page,
        page_size: pageSize
      }


      if (search) {
        params.search = search.trim() || ''
      }


      if (sort) {
        params.ordering = order === 'desc' ? `-${sort}` : sort
      }


      //Add each filter as a query param 
      if (filters && Array.isArray(filters)) {
        filters.forEach(filter => {
          const { id, value } = filter
          if (!id || value === undefined || value === '') return

          if (
            (id === 'updated_at' || id === 'created_at') &&
            typeof value === 'object'
          ) {
            const { from_date, to_date } = value as {
              from_date?: string
              to_date?: string
            }
            if (id === 'updated_at') {
              if (from_date) params['updated_at_from'] = from_date
              if (to_date) params['updated_at_to'] = to_date
            }
            if (id === 'created_at') {
              if (from_date) params['created_at_from'] = from_date
              if (to_date) params['created_at_to'] = to_date
            }

          } else {
            params[id] = value
          }

        })
      }




      console.log('Final query params:', params)

      const response = await Axios.get(`/user-types/`, { params })
      const responseData = response.data

      return {
        data: responseData.data || responseData.results || [],
        rowCount: responseData.count || 0
      }
    } catch (error: any) {
      console.error('fetchUsersType error:', error.response?.data || error.message)
      throw new Error('Failed to fetch user types')
    }
  }
)



export const fetchUsersTypesById = createAsyncThunk(
  'usersTypes/fetchById',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`${API_URL}/organisation/${id}/`)
      console.log('resp to update Id : ', response)
      return response
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || 'Failed to fetch organisations by ID'
      )
    }
  }
)

export const updateUsersTypes = createAsyncThunk(
  'usersTypes/updateOrganisation',
  async (orgData: any) => {
    const response: any = await Axios.put(
      `${API_URL}/organization/${orgData?.organization_id}/update/`,
      orgData
    )
    return response
  }
)
export const updateStatusInUsersTypes = createAsyncThunk(
  'usersTypes/updateStatusInUsersTypes',
  async (user_type_id: any) => {
    const response: any = await Axios.put(
      `${API_URL}/user-types/${user_type_id?.user_type_id}/update/`,
      user_type_id
    )
    return response
  }
)

export const addUsersTypes = createAsyncThunk(
  'usersTypes/addUsers',
  async (packageData: any) => {
    // const token = localStorage.getItem("authToken");
    // if (!token) {
    //   throw new Error("No authentication token found");
    // }

    const response = await Axios.post(`${API_URL}/organisation/`, packageData)
    console.log('addOrganisation response:', response)
    console.log('addOrganisation response:', response.data)
    return response.data
  }
)

export const deleteOrganisation = createAsyncThunk(
  'packages/delete',
  async (id: number, { rejectWithValue }) => {
    try {
      await axios.delete(`${API_URL}/${id}`, { headers })
      return id
    } catch (err: any) {
      console.error('Delete error:', err)
      return rejectWithValue(err.response?.data?.message || err.message)
    }
  }
)

export const fetchAllDropdownsUsersTypes = createAsyncThunk(
  'usersTypes/fetchAllDropdownsUsersTypes',
  async () => {
    try {
      const [usersRes, industryRes, cityRes, stateRes, pincodeRes] =
        await Promise.all([
          Axios.get(`${API_URL}/api/users/dropdown/`, { headers }),
          Axios.get(`${API_URL}/organization/dropdown/industry_type/`, {
            headers
          }),
          Axios.get(`${API_URL}/organization/dropdown/org_city/`, {
            headers
          }),
          Axios.get(`${API_URL}/organization/dropdown/org_state/`, {
            headers
          }),
          Axios.get(`${API_URL}/organization/dropdown/org_pincode/`, {
            headers
          })
        ])
      console.log(usersRes, 'usersRes')

      // console.log(orgRes,"orgRes");
      // console.log(industryRes,"industryRes")
      // console.log(cityRes,"cityRes")
      // console.log(stateRes,"stateRes")

      return {
        usersRes: Array.isArray(usersRes.data.data)
          ? usersRes.data.data.map((item: any) => item.first_name)
          : [],
        industryTypeDropDown: Array.isArray(industryRes.data.industry_type)
          ? Array.from(new Set(industryRes?.data?.industry_type))
          : [],
        orgCityDropDown: Array.isArray(cityRes.data.org_city)
          ? Array.from(new Set(cityRes?.data?.org_city))
          : [],
        orgStateDropDown: Array.isArray(stateRes.data.org_state)
          ? Array.from(new Set(stateRes?.data?.org_state))
          : [],
        pincodeDropDown: Array.isArray(pincodeRes?.data?.org_pincode)
          ? Array.from(new Set(pincodeRes?.data?.org_pincode))
          : []
      }
    } catch (err) {
      console.log(err)
      throw err
    }
  }
)
//Exports csv file
// Exports department CSV file
export const exportetchUsersTypes = createAsyncThunk(
  'usersTypes/exportetchUsersTypes',
  async (params: { search?: string; filters?: any }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('authToken');
      const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        Accept: '*/*'
      };

      // Build query string from params (e.g. search, filters)
      const query = new URLSearchParams({
        export: 'excel',
        ...(params.search ? { search: params.search } : {}),
        // Add other filters here if applicable
      }).toString();

      const response = await Axios.get(`/user-types/?${query}`, {
        headers,
        responseType: 'blob'
      });

      return {
        blob: response.data,
        filename:
          response.headers['content-disposition']
            ?.split('filename=')[1]
            ?.replace(/"/g, '') || 'usersTypes.csv'
      };
    } catch (err: any) {
      console.error('Export CSV error:', err);
      return rejectWithValue(err.message || 'Failed to export CSV');
    }
  }
);


export const UsersTypesxportsCSV = async ({
  search,
  filters,
}: {
  search?: string;
  filters?: any;
}) => {
  const params = new URLSearchParams();
  params.append("export", "excel");

  if (search) params.append("search", search);

  if (filters && filters.length > 0) {
    filters.forEach(
      ({
        id,
        value,
      }: {
        id: string;
        value: any;
      }) => {
        if (id && value !== undefined && value !== null) {
          if (typeof value === "object" && value !== null) {
            // Type guard for date filter
            const maybeDateFilter = value as {
              from_date?: string;
              to_date?: string;
            };

            if (
              (maybeDateFilter.from_date || maybeDateFilter.to_date) &&
              (id === "created_at" || id === "updated_at")
            ) {
              const filterId = id === "created_at" ? "created" : "updated";

              if (maybeDateFilter.from_date) {
                params.append("from_date", maybeDateFilter.from_date);
              }

              if (maybeDateFilter.to_date) {
                params.append("to_date", maybeDateFilter.to_date);
              }

              params.append(filterId, "true");
              return;
            }

            // Add all other key-values
            Object.entries(value).forEach(([key, val]) => {
              if (val !== undefined && val !== null && val !== "") {
                params.append(key, String(val));
              }
            });
          } else {
            params.append(id, value);
          }
        }
      }
    );
  }

  const response = await Axios.get(`/user-types/?${params.toString()}`, {
    responseType: "blob",
  });

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "Userstype.csv",
  };
};